var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuppliersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3868 12.6035C14.4872 12.2146 14.8839 11.9807 15.2728 12.0811C16.0529 12.2826 16.744 12.7374 17.2376 13.3741C17.7312 14.0109 17.9994 14.7936 18 15.5993V17.0544C18 17.456 17.6744 17.7816 17.2727 17.7816C16.8711 17.7816 16.5455 17.456 16.5455 17.0544V15.6004C16.5451 15.117 16.3842 14.6473 16.088 14.2653C15.7919 13.8832 15.3772 13.6103 14.9091 13.4895C14.5202 13.3891 14.2864 12.9924 14.3868 12.6035Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4773 3.87775C11.577 3.48864 11.9732 3.25397 12.3623 3.3536C13.1445 3.55387 13.8377 4.00878 14.3328 4.6466C14.8279 5.28442 15.0966 6.06887 15.0966 6.87629C15.0966 7.68371 14.8279 8.46816 14.3328 9.10598C13.8377 9.7438 13.1445 10.1987 12.3623 10.399C11.9732 10.4986 11.577 10.2639 11.4773 9.87483C11.3777 9.48572 11.6124 9.08953 12.0015 8.9899C12.4708 8.86974 12.8868 8.5968 13.1838 8.21411C13.4809 7.83141 13.6421 7.36074 13.6421 6.87629C13.6421 6.39184 13.4809 5.92117 13.1838 5.53847C12.8868 5.15578 12.4708 4.88284 12.0015 4.76268C11.6124 4.66305 11.3777 4.26685 11.4773 3.87775Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81812 4.69086C6.61315 4.69086 5.63632 5.66768 5.63632 6.87265C5.63632 8.07762 6.61315 9.05445 7.81812 9.05445C9.02309 9.05445 9.99991 8.07762 9.99991 6.87265C9.99991 5.66768 9.02309 4.69086 7.81812 4.69086ZM4.18179 6.87265C4.18179 4.86437 5.80983 3.23633 7.81812 3.23633C9.8264 3.23633 11.4544 4.86437 11.4544 6.87265C11.4544 8.88094 9.8264 10.509 7.81812 10.509C5.80983 10.509 4.18179 8.88094 4.18179 6.87265Z",
    fill: "#4F5E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63632 13.418C4.43135 13.418 3.45453 14.3949 3.45453 15.5998V17.0544C3.45453 17.456 3.12892 17.7816 2.72726 17.7816C2.32561 17.7816 2 17.456 2 17.0544V15.5998C2 13.5915 3.62804 11.9635 5.63632 11.9635H9.99991C12.0082 11.9635 13.6362 13.5915 13.6362 15.5998V17.0544C13.6362 17.456 13.3106 17.7816 12.909 17.7816C12.5073 17.7816 12.1817 17.456 12.1817 17.0544V15.5998C12.1817 14.3949 11.2049 13.418 9.99991 13.418H5.63632Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliersIcon);
export default __webpack_public_path__ + "static/media/suppliersIcon.acb3b31ad98daebd0742a2325d37049e.svg";
export { ForwardRef as ReactComponent };